
<div class="build-info" v-if="buildInfo && buildInfo.buildNumber">
  {{ buildInfo.buildNumber }}
</div>
